import http from "src/_services/httpService";
import { $BASE_URL } from "src/constants";
import { pickBy } from "lodash";
const apiUrl = `${$BASE_URL}/api/v1/blog`;
const apiFileUrl = `${$BASE_URL}/api/v1/file`;

const createBlogPost = (payload) => {
    return http.post(`${apiUrl}`, payload);
}
const updateBlogPost = (id, payload) => {
    return http.put(`${apiUrl}/${id}`, payload);
}
const getBlogPosts = (page = 1, limit = 20, searchKey) => {
    return http.get(`${apiUrl}/admin?page=${page}&limit=${limit}${searchKey ? `&searchKey=${searchKey}` : ''}`);
}

const getBlogPostsPublic = (page = 1, limit = 6, searchKey) => {
    const params = pickBy(
        { page, limit, searchKey },
        value => !!value
    )
    const searchParams = new URLSearchParams(params).toString();
    const url = `${apiUrl}?${searchParams}`
    return http.get(url);
}

const getBlogPostById = (id) => {
    return http.get(`${apiUrl}/admin/${id}`);
}
const getBlogPostBySlug = (slug) => {
    return http.get(`${apiUrl}/single/${slug}`);
}
const deleteBlogPost = (id) => {
    return http.delete(`${apiUrl}/${id}`);
}
const getAdminBlogImages = ({ page = 1, limit = 20 }) => {
    return http.get(`${apiFileUrl}?page=${page}&limit=${limit}`);
}
const deleteAdminBlogImage = (id) => {
    return http.delete(`${apiFileUrl}/${id}`);
}
const uploadAdminBlogImage = (payload) => {
    return http.post(`${apiFileUrl}`, payload);
}
const BlogPostService = {
    createBlogPost,
    updateBlogPost,
    getBlogPosts,
    getBlogPostById,
    deleteBlogPost,
    getBlogPostsPublic,
    getBlogPostBySlug,
    getAdminBlogImages,
    deleteAdminBlogImage,
    uploadAdminBlogImage
};

export default BlogPostService;
